import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  CommandDashboardKeys,
  getMasterSchedulerTileMetrics,
} from '../../api/command-dashboard-api';
import { handleErrors } from '../../utils/errors';
import { Messages } from '../../utils/message-constants';
import { useTrackCommandDashboardTileRefresh } from './use-tile-refresh';

export function useMasterSchedulerTileMetrics(enabled = true) {
  const trackRefresh = useTrackCommandDashboardTileRefresh();

  const query = useQuery({
    queryKey: [CommandDashboardKeys.MasterSchedulerTile],
    queryFn: getMasterSchedulerTileMetrics,
    enabled,
    placeholderData: keepPreviousData,
    meta: {
      errorMessage: Messages.CommandDashboard.MasterSchedulerTileLoadError,
    },
  });

  const onRefresh = async () => {
    try {
      await query.refetch({ throwOnError: true });
      trackRefresh();
    } catch (error) {
      handleErrors({
        error,
        snackbarMessage:
          Messages.CommandDashboard.MasterSchedulerTileRefreshError,
      });
    }
  };

  const snapshot = query.data;

  return {
    jobs: snapshot?.jobs ?? [],
    successfulJobs: snapshot?.successfulJobs ?? 0,
    jobsCompletedToday: snapshot?.jobsCompletedToday ?? 0,
    jobsFailedLast24h: snapshot?.jobsFailedLast24h ?? 0,
    jobsCurrentlyRunning: snapshot?.jobsCurrentlyRunning ?? 0,
    lastUpdated: snapshot?.lastUpdated ?? null,
    hasLoadedData: snapshot !== undefined,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    onRefresh,
  };
}
